export default class Video {
    constructor({el}) {
        this.rendered = false;
        this.el = el;
        this.offsetTop = this.getOffsetTop();

        this.bind();
    }

    getOffsetTop() {
        let offsetTop = this.el.offsetTop;
        let el = this.el;

        while (el.offsetParent) {
            offsetTop += el.offsetParent.offsetTop;
            el = el.offsetParent;
        }

        return offsetTop;
    }

    bind() {
        const wh = window.outerHeight === 0 ? window.innerHeight : window.outerHeight;
        const waypoint = this.offsetTop - wh;
        const script = document.createElement('script');
        const inline = document.createTextNode(`(function (d, id) {
            var t, el = d.scripts[d.scripts.length - 1].previousElementSibling;
            if (el) el.dataset.initTimestamp = (new Date()).getTime();
            if (d.getElementById(id)) return;
            t = d.createElement('script');
            t.src = '//assetscdn.stackla.com/media/js/widget/fluid-embed.js';
            t.id = id;
            (d.getElementsByTagName('head')[0] || d.getElementsByTagName('body')[0]).appendChild(t);
        }(document, 'stackla-widget-js'));`);

        script.appendChild(inline);

        this.el.className = `stackla-widget`;
        this.el.setAttribute(`data-alias`, `ttc.stackla.com`);
        this.el.setAttribute(`data-ct`, ``);
        this.el.setAttribute(`data-hash`, `5c63275ea444f`);
        this.el.setAttribute(`data-id`, `53017`);
        this.el.setAttribute(`data-title`, `TreadRight Home Page Widget`);
        this.el.setAttribute(`data-ttl`, `30`);
        this.el.style.width = `100%`;
        this.el.style.overflow = `hidden`;

        window.addEventListener('scroll', evt => {
            if (window.scrollY > waypoint && !this.rendered) {
                this.el.parentNode.appendChild(script);
                this.rendered = true;
            }
        });
    }
}
